module.exports = __webpack_public_path__ + "static/media/Artboard17.68b80570.png";